export const INTERNAL_USER_NAME = 'Kipin';
